var card_product_item_ele = null;
var card_product_form_page = null;

function restoreQuickBuyModal(modal) {
    if (!modal) return;
    var host = modal._quickBuyHost;
    if (host && host.parentNode) {
        host.parentNode.insertBefore(modal, host);
        host.remove();
        modal._quickBuyHost = null;
    }
    modal.style.display = 'none';
}

function closeAllQuickBuyModals() {
    document.querySelectorAll('.quick-buy-modal').forEach(function (modal) {
        restoreQuickBuyModal(modal);
    });
    $('.size-option').removeClass('active');
    $('.size-select').hide();
    $('.color-select').show();
    $('.color-select-tip').html('select color');
}

function openQuickBuyModal(btn) {
    closeAllQuickBuyModals();
    card_product_item_ele = btn.closest('.product-card');
    if (!card_product_item_ele) return;
    card_product_form_page = card_product_item_ele.getAttribute('data-formPage');
    var productId = btn.dataset.productId;
    var modal = card_product_item_ele.querySelector('#modal-' + productId);
    if (!modal) return;
    if (window.matchMedia('(max-width: 1024px)').matches && !modal._quickBuyHost) {
        var host = document.createElement('div');
        host.className = 'quick-buy-modal-host';
        host.hidden = true;
        modal.parentNode.insertBefore(host, modal);
        modal._quickBuyHost = host;
        document.body.appendChild(modal);
    }
    var variantsNode = card_product_item_ele.querySelector('#variants-' + productId);
    modal._quickBuyProductId = productId;
    modal._quickBuyVariantsText = variantsNode ? variantsNode.textContent : '[]';
    modal.style.display = 'flex';
    var colorSelect = modal.querySelector('.color-select');
    var sizeSelect = modal.querySelector('.size-select');
    if (colorSelect) colorSelect.style.display = 'grid';
    if (sizeSelect) sizeSelect.style.display = 'none';
    var tip = modal.querySelector('.color-select-tip');
    if (tip) tip.textContent = 'select color';
}

function init_product_card(){
    document.querySelectorAll('.quick-buy-btn').forEach(btn => {
        if (btn.dataset.quickBuyBound === '1') return;
        btn.dataset.quickBuyBound = '1';
        btn.addEventListener('click', function() {
            openQuickBuyModal(btn);
        });
    });
document.querySelectorAll('.mobile-quick-buy-btn').forEach(btn => {
    if (btn.dataset.quickBuyBound === '1') return;
    btn.dataset.quickBuyBound = '1';
    btn.addEventListener('click', function() {
        openQuickBuyModal(btn);
    });
});

document.querySelectorAll('.close').forEach(span => {
    if (span.dataset.quickBuyBound === '1') return;
    span.dataset.quickBuyBound = '1';
    span.addEventListener('click', function() {
        var productId = span.dataset.productId;
        var modal = document.getElementById('modal-' + productId);
        restoreQuickBuyModal(modal);
    });
});

$(document).off('click.quickBuyClose', '.modal_close_icon').on('click.quickBuyClose', '.modal_close_icon', function(){
    var modal = $(this).closest('.quick-buy-modal').get(0);
    restoreQuickBuyModal(modal);
    if (!modal) return;
    $(modal).find('.size-select').hide();
    $(modal).find('.color-select').show();
    $(modal).find('.color-select-tip').html('select color');
});

$(document).off('click.quickBuyMask', '.quick-buy-modal-mask').on('click.quickBuyMask', '.quick-buy-modal-mask', function () {
    var modal = $(this).closest('.quick-buy-modal').get(0);
    restoreQuickBuyModal(modal);
    if (!modal) return;
    $(modal).find('.size-select').hide();
    $(modal).find('.color-select').show();
    $(modal).find('.color-select-tip').html('select color');
});

}

function getQuickBuyModalContext(element, productId) {
    var modal = element && element.closest ? element.closest('.quick-buy-modal') : null;
    if (!modal && productId) {
        modal = document.getElementById('modal-' + productId);
    }
    return modal;
}

function selectColor(element, productId, selectedColor, product_title) {
    var modal = getQuickBuyModalContext(element, productId);
    if (!modal) return;
    var colorSelect = modal.querySelector('.color-select');
    var sizeSelect = modal.querySelector('.size-select');
    var tip = modal.querySelector('.color-select-tip');
    var colorValue = (element && element.getAttribute('data-color')) || selectedColor;
    if (typeof colorValue === 'string') colorValue = colorValue.trim();
    if (tip) tip.textContent = 'select size';
    updateSizeOptions(productId, colorValue, colorSelect, sizeSelect, product_title, modal);
}

function getVariantSizeLabel(variant, selectedColor) {
    if (variant.option1 === selectedColor) return variant.option2 || variant.option3 || '';
    if (variant.option2 === selectedColor) return variant.option1 || variant.option3 || '';
    if (variant.option3 === selectedColor) return variant.option2 || variant.option1 || '';
    return variant.option2 || '';
}

function updateSizeOptions(productId, selectedColor, colorSelect, sizeSelect, product_title, modal) {
    if (!sizeSelect || !colorSelect) return;
    var variantsText = (modal && modal._quickBuyVariantsText) || '';
    if (!variantsText) {
        var variantsNode = (card_product_item_ele && card_product_item_ele.querySelector('#variants-' + productId)) || document.getElementById('variants-' + productId);
        variantsText = variantsNode ? variantsNode.textContent : '[]';
    }
    var variants = [];
    try {
        variants = JSON.parse(variantsText);
    } catch (e) {
        variants = [];
    }
    sizeSelect.innerHTML = '';
    var sizes = variants.filter(function (v) {
        return v.option1 === selectedColor || v.option2 === selectedColor || v.option3 === selectedColor;
    });
    sizes.forEach(function (v) {
        var sizeLabel = getVariantSizeLabel(v, selectedColor);
        var option = document.createElement('div');
        option.classList.add('size-option');
        option.dataset.size = sizeLabel;
        option.dataset.title = product_title;
        if (!v.available) {
            option.innerHTML = '<img class="size-email-icon" src="https://cdn.shopify.com/s/files/1/0601/6981/4121/files/Shopicon.svg?v=1756220751" /><span class="size-text-disabled">' + sizeLabel + '</span>';
            option.classList.add('disabled');
            option.disabled = true;
        } else {
            option.textContent = sizeLabel;
        }
        option.addEventListener('click', function () {
            if (!v.available) {
                $('.notify-me-pupopbox').fadeIn(300).addClass('card_notify_me_pupopbox');
                var notify_product_size_name = $(this).attr('data-size');
                var notify_product_title = $(this).attr('data-title');
                $(this).addClass('active').siblings().removeClass('active');
                $('#notify_form_product_title').val(notify_product_title);
                $('#notify_form_product_size').val(notify_product_size_name);
                return;
            }
            addToCart(productId, v.id, this);
        });
        sizeSelect.appendChild(option);
    });
    colorSelect.style.display = 'none';
    sizeSelect.style.display = 'grid';
}

// 选择尺码
function selectSize(productId, selectedSize, variantId) {
    const sizeSelect = document.getElementById('size-' + productId);
    const addToCartBtn = document.getElementById('add-to-cart-' + productId);

    // 更新尺码显示
    // sizeSelect.querySelector('.size-option').textContent = selectedSize;

    // 启用加入购物车按钮
    addToCartBtn.disabled = false;
    addToCartBtn.onclick = function() {
        addToCart(productId, variantId);
    };
}
var createCartPromise_two = () => {
    return new Promise(async(resolve) => {
        resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
    });
};
// 添加到购物车
function addToCart(productId, variantId, element) {
    const quantity = document.getElementById('quantity-' + productId).value;
    var cart_section_id = localStorage.getItem('cart_id');
    fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: variantId,
                    quantity: quantity
                }],
                sections: cart_section_id
            })
        })
        .then(response => {
                if (response.ok) {
                    return response.json()
                } else {
                    if (response.status == 422) {
                        document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: 'The maximum quantity of this item is already in your cart.', tone: 'error' } }));
                    }
                }

            }

        )
        .then(async data => {
            if (data) {
                restoreQuickBuyModal(document.getElementById('modal-' + productId));
                let return_html = data.sections[cart_section_id];
                const cartDrawerSection = document.querySelector('#shopify-section-' + cart_section_id);
                if (cartDrawerSection) {
                    cartDrawerSection.remove();
                }
                document.body.insertAdjacentHTML('beforeend', return_html);
                let res = await createCartPromise_two();
                if (res) {
                    document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: res } }));
                    if(card_product_form_page == 'cart_drawer'){
                         document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: res } }));
                    }else{
                        document.querySelector('.nav-meun-rt-item-cart-open').click();
                    }
                    
                }
                $(element).parent().hide();
                $(element).parent().prev().find('.color-select').show();
                $(element).parent().prev().find('.color-select-tip').html('select color');
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
}

init_product_card();
document.addEventListener('DOMContentLoaded', function() {
const searchPanel = document.querySelector('search-result-panel');
if(searchPanel){
    searchPanel.addEventListener('searchComplete', (e) => {
        init_product_card();
    });
}
});

//监听 cart:refresh 事件 执行 init_product_card
document.addEventListener('swiper:cart', function(e) {
    // console.log('swiper:cart 事件触发');
    init_product_card();
});
//监听 facet:update 事件 执行 init_product_card
document.addEventListener('facet:update', function(e) {
    console.log('facet:update 事件触发');
    console.log(e);
    if(e.detail.scrollTo == "#collection"){
        setTimeout(function(){
             init_product_card();
        },3000)
    }
   // init_product_card();
});
//监听自定义事件 predictive-search:results
document.addEventListener('predictive-search:results', function(event) {
    if(window.innerWidth < 1025){
        if($('.predictive-search__suggestions').attr('data-total_results') != undefined){
              $('.mobile-search-top span').text($('.predictive-search__suggestions').attr('data-total_results') + ' results');
        }else{
            $('.mobile-search-top span').text('0 results');
        }
       
    }
     init_product_card();
});
